type Option = {
  value: string | number;
  text?: string | number;
};

export type NsSelectOptionsProps = {
  options?: Option[];
  placeholder?: string;
};

export const NsSelectOptions = ({ placeholder, options = [] }: NsSelectOptionsProps) => [
  ...(placeholder
    ? [
        <option value="" key="placeholder">
          {placeholder}
        </option>
      ]
    : []),
  ...options.map((option) => (
    <option key={option.value} value={option.value}>
      {option.text || option.value}
    </option>
  ))
];
